export default __webpack_public_path__ + "static/media/TickMark.36423e85.svg";